var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRCartBuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-cart-buy",
    x: 0.829,
    y: 0.131,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconR-cart-buy1",
    serifid: "iconR-cart-buy",
    d: "M6.461,17.143c-1.103,-0 -1.999,0.895 -1.999,1.998c0,1.103 0.896,1.998 1.999,1.998c1.102,0 1.998,-0.895 1.998,-1.998c-0,-1.103 -0.896,-1.998 -1.998,-1.998Zm11.384,-0.004c-1.103,0 -1.998,0.896 -1.998,1.998c-0,1.103 0.895,1.999 1.998,1.999c1.103,-0 1.998,-0.896 1.998,-1.999c0,-1.102 -0.895,-1.998 -1.998,-1.998Zm-13.478,-12.008c0,-0 -2.028,-0.012 -2.031,-0.012c-0.248,-0 -0.504,-0.248 -0.504,-0.521l0,-0.468c0,-0.267 0.258,-0.513 0.504,-0.513c0.001,-0 2.592,0.012 2.592,0.012c-0,-0 0.526,-0.002 0.714,0.513c0.261,0.715 0.28,0.759 0.364,0.989c0.245,0 0.79,-0 2.211,-0c0.021,-0 0.041,0.008 0.056,0.023c0.015,0.015 0.024,0.035 0.024,0.056l-0,1.343c-0,0.044 -0.036,0.079 -0.08,0.079c0,0 -1.668,0.004 -1.668,0.004l3.228,8.869c-0,-0 11.517,-2.669 11.517,-2.669c-0,-0 -0.001,-6.207 -0.001,-6.207l-1.355,0c-0.044,0 -0.08,-0.035 -0.08,-0.079l-0,-1.34c-0,-0.021 0.008,-0.041 0.023,-0.056c0.015,-0.015 0.035,-0.023 0.057,-0.023l1.884,0c0.528,-0 1.007,0.501 1.007,1c0,0.012 -0.003,5.405 -0.003,7.004c0,0.87 -0.73,1.065 -0.937,1.12c-0,-0 -11.6,2.665 -12.462,2.862c-0.175,0.04 -0.302,0.01 -0.337,0.004c-0.386,-0.06 -0.503,-0.395 -0.523,-0.441c0,-0 -3.898,-10.715 -4.2,-11.549Zm9.551,5.979c-0.048,-0.009 -0.145,-0.043 -0.145,-0.043c-0.048,-0.02 -0.088,-0.042 -0.127,-0.067c0,-0 -0.002,-0.001 -0.005,-0.003c-0.044,-0.03 -0.083,-0.062 -0.118,-0.097l-2.465,-2.465c-0.139,-0.138 -0.224,-0.329 -0.224,-0.54c-0,-0.422 0.342,-0.764 0.764,-0.764c0.21,0 0.401,0.086 0.539,0.224l1.163,1.162l-0,-4.623c-0,-0.422 0.342,-0.764 0.764,-0.764c0.421,0 0.763,0.342 0.763,0.764l0,4.623l1.163,-1.162c0.138,-0.138 0.329,-0.224 0.54,-0.224c0.421,0 0.763,0.342 0.763,0.764c0,0.211 -0.085,0.402 -0.224,0.54l-2.464,2.465c-0.036,0.035 -0.075,0.067 -0.116,0.095l-0.13,0.07c-0,0 -0.012,0.004 -0.015,0.006c-0.037,0.015 -0.137,0.04 -0.14,0.04c-0.042,0.009 -0.091,0.013 -0.14,0.013c-0.05,0 -0.098,-0.004 -0.146,-0.014Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRCartBuy);
export default __webpack_public_path__ + "static/media/iconR-cart-buy.4b88d02e18202c24cca36bba83849512.svg";
export { ForwardRef as ReactComponent };